import { Component } from '@angular/core';

@Component({
  selector: 'app-success-simple-icon',
  templateUrl: './success-simple-icon.component.html',
  styles: [
  ]
})
export class SuccessSimpleIconComponent {

}
